import type { MutationHookOptions } from '@apollo/client'
import {
  CreateSessionRelatorioUnicoFieldDocument,
  CreateSessionRelatorioUnicoFieldMutation,
  CreateSessionRelatorioUnicoFieldMutationVariables,
  SessionRelatorioUnicoFieldsDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  CreateSessionRelatorioUnicoFieldMutation,
  CreateSessionRelatorioUnicoFieldMutationVariables
>

export const useCreateSessionRelatorioUnicoField = (options?: Options) => {
  const [createSessionRelatorioUnicoField, { loading }] = useMutation(
    CreateSessionRelatorioUnicoFieldDocument,
    {
      ...options,
      extractorFn: (data) => data.trainingsMutations.createTrainingsSessionRelatorioUnicoField,
    }
  )

  return {
    loading,
    create(variables: CreateSessionRelatorioUnicoFieldMutationVariables) {
      return createSessionRelatorioUnicoField({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [SessionRelatorioUnicoFieldsDocument],
      })
    },
  }
}
